import React from 'react'
import IframeResizer from 'iframe-resizer-react'
import getServerSideAPIProps from '../props/getServerSideAPIProps'

export default function Profile(props) {

  return (
    <IframeResizer
      frameBorder="0px"
      heightCalculationMethod="lowestElement"
      inPageLinks
      log
      scrolling="yes"
      src="https://forms.zohopublic.com/bottlepos/form/BottleZooCustomerFAQ/formperma/JwwYo42nmcr2REkaVPLzXxNxBp1SGXrcD-_X1JlVkWg"
      style={{ minWidth: '100%', height: '1600px' }}
    />
  )
}

export const getServerSideProps = getServerSideAPIProps('/faq')
